import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoaderSpinnerService } from './loader-spinner.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loader-spinner',
  templateUrl: './loader-spinner.component.html',
  styleUrls: ['./loader-spinner.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
  ]
})
export class LoaderSpinnerComponent implements OnInit {

  public show: boolean = false;

  constructor(
    private loaderSpinnerService: LoaderSpinnerService,
    private cdRef: ChangeDetectorRef
  ) { }

  public ngOnInit(): void {
    this.loaderSpinnerService.getSpinner()
      .subscribe((show) => {
        this.show = show;
        this.cdRef.detectChanges();
      });
  }
}
